import React, { useContext } from "react";
import { useHistory } from "react-router";
import { RESOURCE_NAME } from "common/authorization";
import { buildLink } from "common/routing";
import { AuthContext } from "../../../Authorization/AuthContext";
import { Box, FlexRow } from "../../../Common/__styles__/Layout";
import { Button } from "../../../Common/Button";
import {
  Header,
  HeaderTitle,
  HelperText,
  SectionTitle,
  TableWrapper,
} from "../../__styles__/Content";
import SubmissionTypesTable from "./SubmissionTypesTable";

const Records = () => {
  const history = useHistory();
  const { authorized } = useContext(AuthContext);

  const canAddSubmissionType = authorized({
    resource: RESOURCE_NAME.SUBMISSION_TYPE,
    permission: "create",
  });

  return (
    <Box>
      <Header accountSettings>
        <HeaderTitle accountSettings>Records</HeaderTitle>
      </Header>
      <TableWrapper>
        <FlexRow style={{ justifyContent: "space-between" }}>
          <SectionTitle>Record types</SectionTitle>
          <Button
            styleVariant="outlineLight"
            size="small"
            leftIconName="plus"
            onClick={() => {
              history.push({
                pathname: buildLink("submissionsBuilder"),
                state: {
                  prevLocation: history.location.pathname,
                },
              });
            }}
            disabled={!canAddSubmissionType}
          >
            Add record type
          </Button>
        </FlexRow>
        <HelperText>
          Add and/or edit record types for internal and public-facing forms.
        </HelperText>
        <SubmissionTypesTable />
      </TableWrapper>
    </Box>
  );
};

export default Records;
